import React from 'react';
import { Icon } from '../Icon';
import styles from './PlayerBackground.module.scss';
import cx from 'classnames';

const PlayerBackground = ({ isMobile, children, className, ...props }) => {
  return (
    <div className={cx(styles.backgroundWrapper, className)} {...props}>
      <Icon src={isMobile ? 'backgroundMobile' : 'background'} className={styles.backgroundSvg} />
      {children}
    </div>
  );
};

export default PlayerBackground;
